export default "__VITE_ASSET__B7R35rbt__"